import React from "react";
import {
  renderMultipleCommasWithDescription,
  renderPredictionFromScore,
  renderPredictions,
} from "./InSilicoPredictionsHelpers";
import * as urls from "./InSilicoPredictionsUrls";
import VersionText from "../../../../components/atoms/VersionText";
import HelperText from "../../../../components/atoms/HelperText";

export const displayOtherData = (
  schema,
  genome,
  dbnsfp,
  group,
  name,
  prefix,
  url,
  thresholds,
  helptext
) => {
  const pred = `${prefix}_pred`;
  const score = `${prefix}_score`;
  const rankscore = `${prefix}_rankscore`;
  const labelPred = dbnsfp[pred]
    ? schema.dbnsfp.items.properties[pred].label
    : "";
  const helptextPred = helptext ? helptext.pred : null;
  const labelScore = dbnsfp[score]
    ? schema.dbnsfp.items.properties[score].label
    : "";
  const helptextScore = helptext ? helptext.score : null;
  const labelRankscore = dbnsfp[rankscore]
    ? schema.dbnsfp.items.properties[rankscore].label
    : "";
  const convertedRankscore = `${prefix}_converted_rankscore`;
  const labelConvertedRankscore = dbnsfp[convertedRankscore]
    ? schema.dbnsfp.items.properties[convertedRankscore].label
    : "";

  const omega = `${prefix}_omega`;

  if (prefix === "dann" && genome.id === 1019) {
    return null;
  }

  if (
    dbnsfp[pred] ||
    dbnsfp[score] ||
    dbnsfp[rankscore] ||
    dbnsfp[convertedRankscore] ||
    dbnsfp[omega]
  ) {
    const prediction = dbnsfp[pred]
      ? renderPredictions(dbnsfp, pred, labelPred, group, helptextPred)
      : "";
    const predictionFromScore = dbnsfp[score]
      ? renderPredictionFromScore(prefix, dbnsfp[score], thresholds)
      : "";

    const coloredScoreUsingThreshold =
      dbnsfp[score] && thresholds
        ? renderMultipleCommasWithDescription(
            dbnsfp,
            score,
            labelScore,
            true,
            helptextScore,
            true,
            true,
            thresholds,
            prefix
          )
        : null;
    const scoreFromData = dbnsfp[score]
      ? renderMultipleCommasWithDescription(
          dbnsfp,
          score,
          labelScore,
          true,
          helptextScore
        )
      : null;
    const rankscoreFromData = dbnsfp[rankscore]
      ? renderMultipleCommasWithDescription(
          dbnsfp,
          rankscore,
          labelRankscore,
          true
        )
      : null;
    const convertedRankscoreFromData = dbnsfp[convertedRankscore]
      ? renderMultipleCommasWithDescription(
          dbnsfp,
          `${convertedRankscore}`,
          labelConvertedRankscore,
          true
        )
      : null;
    return (
      <tr key={pred} className="dbnsfp-row">
        <td width="20%">
          {url ? (
            <a href={url} target="_blank">
              {name}
            </a>
          ) : (
            `${name} `
          )}
          <HelperText fieldDescriptionKey={name} />
          <br />
          <VersionText
            anchorUrl={urls.dbnsfpUrl}
            anchorText="dbNSFP"
            versionText={dbnsfp.version}
          />
        </td>
        {prediction || predictionFromScore || <td />}
        {coloredScoreUsingThreshold || scoreFromData || <td />}
        {rankscoreFromData || convertedRankscoreFromData || <td />}
        {dbnsfp[omega] ? (
          renderMultipleCommasWithDescription(
            dbnsfp,
            `${omega}`,
            schema.dbnsfp.items.properties[omega].label,
            true
          )
        ) : (
          <td />
        )}
        <td />
        <td />
      </tr>
    );
  }
  return null;
};
